<script setup lang="ts">
import { Button } from '@/components/ui/button'
import { AutoForm } from '@/ui-plus/auto-form'
import { toast } from '@/ui-plus/sonner'
import { useFormPlus } from "@/ui-plus/form/useFormPlus";
import { toTypedSchema } from "@vee-validate/zod";
import { authGlobalApiClient } from '@api-client/auth_global';
import { useForm } from "vee-validate";
import { z } from "zod";
import { Loader2 } from 'lucide-vue-next';
import { useI18n } from "vue-i18n";
import AutoFormFieldPin from "@/ui-plus/auto-form/AutoFormFieldPin.vue";
import { startRefreshingTokens } from '@api-client/auth/auth';

const { t } = useI18n();

const props = defineProps<{
    otpToken: string;
}>();

const emit = defineEmits<{
    onSuccess: [],
}>();

const schema = z.object({
    code: z.string().length(4, { message: '4 digits required' }),
})

const form = useForm({
    validationSchema: toTypedSchema(schema)
});
const { isLoading, globalError, handleError, withSubmit } = useFormPlus(form);

async function onSubmit(values: z.infer<typeof schema>) {
    await withSubmit(async () => {
        const { error } = await (await authGlobalApiClient.phone.verify_otp.$post({
            form: {
                code: values.code,
                otpToken: props.otpToken,
            },
        })).json()
        if (error) {
            handleError(error, form);
        } else {
            try {
                await startRefreshingTokens();
            } catch {
                // session refresh best-effort; phone is already verified
            }
            toast.success(t('phoneChanged'));
            emit('onSuccess');
        }
    })
}
</script>

<template>
    <AutoForm class="space-y-4"
              :schema="schema"
              :form="form"
              @submit="onSubmit"
              :field-config="{
                code: {
                    component: AutoFormFieldPin,
                    label: t('oneTimePassword'),
                    inputProps: {
                        // @ts-ignore
                        length: 4,
                        autofocus: true,
                    },
                },
            }">
        <div class="text-sm font-medium text-destructive"
             v-if="globalError">
            {{ globalError }}
        </div>
        <div>
            <Button type="submit"
                    :disabled="isLoading"
                    class="w-full my-6">
                <Loader2 v-if="isLoading"
                         class="animate-spin" />
                {{ t('verify') }}
            </Button>
        </div>
    </AutoForm>
</template>
